import NativeAppPrompt from '~/components/payment/deposit/components/native-app-prompt.js';
import MobilepayNativePrompt from '~/components/payment/deposit/components/mobilepay-native-prompt.js';
import SwishAppPrompt from '~/components/payment/deposit/components/swish-app-prompt.js';
import { SWISH } from '../../beta/constants.js';

const getMethodCode = methodCode => {
	switch (true) {
		case methodCode === SWISH:
			return SWISH;
		case methodCode === 'TRUSTLY_SWISH':
			return SWISH;
		case methodCode === 'ADYEN_SWISH':
			return SWISH;
		case methodCode?.includes(SWISH):
			return SWISH;

		default:
			return methodCode;
	}
};

const NativePrompts = ({
	result,
	methodDetails,
	payment,
	cancelAppDepositRequest,
	handleAppDepositRequestSuccess,
	quickDepositFlow
}) => {
	const { appUrl, externalParameters } = result?.sendHandlerData || result || {};
	const { methodCode } = payment?.status?.selectedMethodDetails || methodDetails || {};

	const externalUrl = methodDetails?.signUpUrl || appUrl;
	const deducedMethodCode = getMethodCode(methodCode);
	const QRCodedata = externalParameters?.qr && `data:image/png;base64,${externalParameters?.qr}`;

	if (deducedMethodCode === 'ADYEN_MOBILEPAY')
		return (
			<MobilepayNativePrompt
				quickDepositFlow={quickDepositFlow}
				onPaymentSuccess={handleAppDepositRequestSuccess}
				paymentResult={result}
			/>
		);

	if (deducedMethodCode === SWISH)
		return (
			<SwishAppPrompt
				quickDepositFlow={quickDepositFlow}
				paymentResult={result}
				cancelAppDepositRequest={cancelAppDepositRequest}
				handleAppDepositRequestSuccess={handleAppDepositRequestSuccess}
			/>
		);

	return (
		<NativeAppPrompt
			quickDepositFlow={quickDepositFlow}
			onNoClick={cancelAppDepositRequest}
			accHistRef={result.accHistRef}
			onPaymentSuccess={handleAppDepositRequestSuccess}
			signUpUrl={externalUrl}
			QRCodedata={QRCodedata}
			selectedMethod={deducedMethodCode}
		/>
	);
};

export default NativePrompts;
